/* eslint-disable camelcase */
import { round_by_tick_size } from 'helpers/formulas';
import { addZeroesUntilCorrectPrecision, calcPrecision, isOptions } from 'helpers/utils';
import {
  openPositionBestAskSelectorByProductId,
  openPositionBestBidSelectorByProductId,
  openPositionMarkPriceSelectorByProductId,
} from 'stores/openPosition/openPosition.selectors';
import { selectedProductMarkPriceSelector } from 'stores/selectedProduct/selectedProduct.selectors';
import { OpenPosition } from 'types/IOpenPosition';
import { Product } from 'types/IProducts';

/**
 * Note: THIS IS NOT A HOOK! - Don't add any react based selectors here
 * @param position  position to calculate exit price
 * @param selectedProduct current selectedProduct on trade page
 * @returns price at which position can be closed
 *
 * // TO USE REACTIVE DATA, USE -> `useOpenPositionExitPriceReactive`
 */
const useOpenPositionExitPrice = (
  position: OpenPosition,
  selectedProduct?: Product | null
) => {
  const { product, size } = position || {};
  const { contract_type, tick_size } = product || {};

  const tickPrecision = calcPrecision(tick_size!);

  const selectProductMarkPriceValue = selectedProductMarkPriceSelector(tickPrecision);
  const productId = product?.id!;
  const best_bid = openPositionBestBidSelectorByProductId(productId);
  const best_ask = openPositionBestAskSelectorByProductId(productId);
  const mark_price = openPositionMarkPriceSelectorByProductId(Number(productId));

  if (isOptions(contract_type)) {
    return Number(size) > 0 ? Number(best_bid) : Number(best_ask);
  }

  const price =
    selectedProduct?.id === product?.id
      ? Number(selectProductMarkPriceValue)
      : Number(mark_price);

  return addZeroesUntilCorrectPrecision(
    round_by_tick_size(price, tick_size || 0.1),
    tick_size
  );
};

export default useOpenPositionExitPrice;
